/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationsControllerFindActivitiesQueryResponse, WorkflowApplicationsControllerFindActivitiesPathParams, WorkflowApplicationsControllerFindActivitiesQueryParams, WorkflowApplicationsControllerFindActivities401, WorkflowApplicationsControllerFindActivities403 } from "../../models/workflowsController/WorkflowApplicationsControllerFindActivities";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { workflowApplicationsControllerFindActivities } from "../../clients/workflowsService/workflowApplicationsControllerFindActivities";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const workflowApplicationsControllerFindActivitiesQueryKey = (id: WorkflowApplicationsControllerFindActivitiesPathParams["id"], params: WorkflowApplicationsControllerFindActivitiesQueryParams = {}) => [{
  url: '/api/v1/workflow-applications/:id/activities',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type WorkflowApplicationsControllerFindActivitiesQueryKey = ReturnType<typeof workflowApplicationsControllerFindActivitiesQueryKey>;
export function workflowApplicationsControllerFindActivitiesQueryOptions(id: WorkflowApplicationsControllerFindActivitiesPathParams["id"], params?: WorkflowApplicationsControllerFindActivitiesQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = workflowApplicationsControllerFindActivitiesQueryKey(id, params);
  return queryOptions<WorkflowApplicationsControllerFindActivitiesQueryResponse, ResponseErrorConfig<WorkflowApplicationsControllerFindActivities401 | WorkflowApplicationsControllerFindActivities403>, WorkflowApplicationsControllerFindActivitiesQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return workflowApplicationsControllerFindActivities(id, params, config);
    }
  });
}

/**
 * @summary Curated activity history for a workflow application
 * {@link /api/v1/workflow-applications/:id/activities}
 */
export function useWorkflowApplicationsControllerFindActivities<TData = WorkflowApplicationsControllerFindActivitiesQueryResponse, TQueryData = WorkflowApplicationsControllerFindActivitiesQueryResponse, TQueryKey extends QueryKey = WorkflowApplicationsControllerFindActivitiesQueryKey>(id: WorkflowApplicationsControllerFindActivitiesPathParams["id"], params?: WorkflowApplicationsControllerFindActivitiesQueryParams, options: {
  query?: Partial<QueryObserverOptions<WorkflowApplicationsControllerFindActivitiesQueryResponse, ResponseErrorConfig<WorkflowApplicationsControllerFindActivities401 | WorkflowApplicationsControllerFindActivities403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? workflowApplicationsControllerFindActivitiesQueryKey(id, params);
  const query = useQuery({
    ...workflowApplicationsControllerFindActivitiesQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WorkflowApplicationsControllerFindActivities401 | WorkflowApplicationsControllerFindActivities403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}